"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenAllowanceOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var dataTypes_1 = require("../../dataTypes");
var EvmChainResolver_1 = require("../../EvmChainResolver");
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */
exports.getTokenAllowanceOperation = {
    method: 'GET',
    name: 'getTokenAllowance',
    id: 'getTokenAllowance',
    groupName: 'token',
    urlPathPattern: '/erc20/{address}/allowance',
    urlPathParamNames: ['address'],
    urlSearchParamNames: ['chain', 'ownerAddress', 'spenderAddress'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams(request, core) {
    return {
        chain: EvmChainResolver_1.EvmChainResolver.resolve(request.chain, core).apiHex,
        owner_address: dataTypes_1.EvmAddress.create(request.ownerAddress, core).lowercase,
        spender_address: dataTypes_1.EvmAddress.create(request.spenderAddress, core).lowercase,
        address: dataTypes_1.EvmAddress.create(request.address, core).lowercase,
    };
}
function deserializeResponse(jsonResponse) {
    return {
        allowance: common_core_1.BigNumber.create(jsonResponse.allowance),
    };
}
function serializeRequest(request, core) {
    return {
        chain: EvmChainResolver_1.EvmChainResolver.resolve(request.chain, core).apiHex,
        ownerAddress: dataTypes_1.EvmAddress.create(request.ownerAddress, core).checksum,
        spenderAddress: dataTypes_1.EvmAddress.create(request.spenderAddress, core).checksum,
        address: dataTypes_1.EvmAddress.create(request.address, core).checksum,
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        chain: dataTypes_1.EvmChain.create(jsonRequest.chain, core),
        ownerAddress: dataTypes_1.EvmAddress.create(jsonRequest.ownerAddress, core),
        spenderAddress: dataTypes_1.EvmAddress.create(jsonRequest.spenderAddress, core),
        address: dataTypes_1.EvmAddress.create(jsonRequest.address, core),
    };
}
//# sourceMappingURL=getTokenAllowanceOperation.js.map